import request from '../utils/request'
import { getToken } from '../utils/auth'

export function fetchNationList(filter) {
  return request({
    url: '/api/nations',
    method: 'get',
    params: {
      filter,
      'access_token': getToken()
    }
  })
}

export function createNation(data) {
  return request({
    url: '/api/nations',
    method: 'post',
    params: {
      'access_token': getToken()
    },
    data
  })
}
